<li>
    <button class="menu-button font-12 cursor-pointer"
            type="button"
            [ngClass]="{ 'bg-style': isActive(), 'bg-light': !isActive() }"
            (click)="buttonClick.emit()">
        <div class="menu-button-content">
            <div class="menu-button-label font-bold"
                 [ngClass]="{
                    'module-label font-regular' : isModule(),
                    'option-label': isOption(),
                    'active-label': isActive(),
                }">
                {{ subtitle() }}
            </div>
            @if (isOpen() !== undefined) {
                <img [ngClass]="{ 'rotate': isOpen() }"
                     ngSrc="/assets/img/icons/black-arrow.svg"
                     width="24" height="24"
                     alt=""/>
            }
        </div>
    </button>
</li>
